








































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
import BasePagination from '@/base/BasePagination.vue';
import LayoutApp from '@/layputs/LayoutApp.vue';
import TheTableAddresses from '@/components/addresses/TheTableAddresses.vue';
// Importing function
import {getAddresses} from '@/ts/profile/addresses/get-addresses';

export default {
    name: 'PageAddresses',
    components: {
        BaseButton,
        BaseCard,
        BasePagination,
        BaseInputField,
        LayoutApp,
        TheTableAddresses,
    },
    props: {},
    data() {
        return {
            items: [],
            search_param: '',
        };
    },
    methods: {
        // Switching between pages
        switchPage(page) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setCurrentPage', page);
            getAddresses().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        onSubmit() {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setQueryParam', this.search_param);
            getAddresses().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    mounted() {
        // Initializing the items object
        this.items = [{
            text: 'Адреси',
        }];
        // Clearing up parameters
        this.$store.dispatch('setCurrentPage', 1);
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        // Starting loading animation
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getAddresses().finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
